module.exports = __webpack_public_path__ + "img/DerAufprall2.51331212.jpg";